import util from '../util'

let controller = 'TemplateNotificacao'
export default Object.assign({}, util.GetCrud(controller, ['get', 'post', 'put', 'persist', 'delete']), {
    GetAll(dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller, dto)
    }
})
